module.exports = __webpack_public_path__ + "static/media/side_menu_logo.8234a859.svg";